var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlayNext = function SvgPlayNext(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47592 5.41587L8.52543 5.44888L14.9199 9.71185L14.966 9.74261C15.4909 10.0924 15.9531 10.4005 16.2767 10.693C16.6209 11.004 16.9472 11.4189 16.9472 12C16.9472 12.581 16.6209 12.996 16.2767 13.3069C15.9531 13.5995 15.4909 13.9075 14.966 14.2574L14.9199 14.2881L8.52543 18.5511L8.47594 18.5841C7.83396 19.0121 7.28248 19.3798 6.82384 19.5964C6.35266 19.819 5.76113 19.9885 5.17425 19.6744C4.58737 19.3603 4.40029 18.7741 4.32408 18.2586C4.24991 17.7569 4.24995 17.0941 4.25 16.3225V16.3225L4.25 16.263V7.73702L4.25 7.67751V7.67747C4.24995 6.9059 4.24991 6.2431 4.32408 5.74136C4.40029 5.22586 4.58737 4.63966 5.17425 4.32557C5.76113 4.01148 6.35266 4.18099 6.82384 4.40353C7.28247 4.62013 7.83395 4.98783 8.47592 5.41587ZM20.75 5.00002C20.75 4.58581 20.4142 4.25002 20 4.25002C19.5858 4.25002 19.25 4.58581 19.25 5.00002L19.25 19C19.25 19.4142 19.5858 19.75 20 19.75C20.4142 19.75 20.75 19.4142 20.75 19V5.00002Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Play - Next.6b13eaf8b8723489dbab7745437ab202.svg";